import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import GlobalErrorBoundary from 'Common/Components/GlobalErrorBoundary';
import HistoryObserver from 'Common/Components/HistoryObserver';
import {
  ForgotPassword,
  InstantLogin,
  Login,
  Pin,
  ResetPassword,
} from 'Account';
import { Welcome } from 'Home';
import ErrorBoundary from 'Common/pages/error';
import LegalRouter from 'Legal/Router';
import InventoryRouter from 'Inventory/Router';
import ContactsRouter from 'Contacts/Router';
import ReportsRouter from 'Reports/router';
import ShorePayRouter from 'ShorePay/Router';
import AppsRouter from 'AppsManagement/Router';
import DatevSection from 'Datev/router';
import KSVRouter from 'KSV/Router';
import withPusher from 'Common/HOC/withPusher';
import RKSVRouter from 'RKSV/Router';
import SettingsRouter from 'Settings/Router';
import { PublicRoute, PrivateRoute, PinRoute } from './AppRouters';

const Router = () => (
  <GlobalErrorBoundary>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<ErrorBoundary />} />
        <Route path="/instant-login" element={<InstantLogin />} />
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        <Route element={<PinRoute />}>
          <Route path="/pin" element={<Pin />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route index element={<Welcome />} />
          <Route path="/inventory/*" element={withPusher(InventoryRouter)} />
          <Route path="/imprint" element={<LegalRouter />} />
          <Route path="/api-apps" element={<AppsRouter />} />
          <Route path="/integrations/rksv/*" element={<RKSVRouter />} />
          <Route
            path="/integrations/kassensichv"
            element={withPusher(KSVRouter)}
          />
          <Route path="/settings/*" element={withPusher(SettingsRouter)} />
          <Route path="/contacts/*" element={withPusher(ContactsRouter)} />
          <Route path="/shorepay/*" element={withPusher(ShorePayRouter)} />
          <Route path="/reports/*" element={withPusher(ReportsRouter)} />
          <Route path="/integrations/datev/*" element={<DatevSection />} />
        </Route>
      </Routes>
      <HistoryObserver />
    </BrowserRouter>
  </GlobalErrorBoundary>
);

export default Router;
